// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"210":"e33b0ad6","255":"0940a5c3","312":"3d7fd740","477":"43161fb1","538":"0d6d335f","757":"8bc7376f","764":"bed2fb73","812":"b33a6f6e","851":"62c527bb"}[chunkId] + ".js";
};